import { RootState } from "../../../../../store";
import { commitmentsForGranularSelector } from "../source/commitmentsForGranularSelector";

export const commitmentsForGranularLoadingSelector = (
  state: RootState,
): boolean => {
  return !!commitmentsForGranularSelector(state)?.isLoading;
};
